import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import MakeAsyncFunction from 'react-redux-promise-listener';
import { promiseListener } from 'store';

const Form: React.FC<any> = (props: any): JSX.Element => {
  const { children, startSubmitAction, resolveSubmitAction, setPayload, initialValues } = props;
  return (
    <MakeAsyncFunction
      listener={promiseListener}
      start={startSubmitAction}
      resolve={resolveSubmitAction}
      reject=""
      setPayload={setPayload}
    >
      {(asyncFunction: any) => (
        <FinalForm
          onSubmit={asyncFunction}
          initialValues={initialValues && initialValues}
          render={formProps => {
            const { handleSubmit } = formProps;
            return <form onSubmit={handleSubmit}>{children(formProps)}</form>;
          }}
        />
      )}
    </MakeAsyncFunction>
  );
};

export default Form;
